<template>
  <div class="echome">
    <router-view :theme="theme"></router-view>
    <loading></loading>
  </div>
</template>

<script>
import { constants } from 'fs';
import { mapGetters } from 'vuex'
import { setInterval } from 'timers';
import loading from '@/components/widgets/Loading'
export default {
  name: 'ECHome',
  //props: ['theme'],
  components: {
    loading,
  },
  data() {
    return {
      theme: window.CurrentTheme,
    }
  },
  created() {    
    console.log('home created');    
    this.setTheme();  //设置主题
    //全局方法
    window.gbfc_setTheme = this.setTheme;
    window.gbfc_getApiHost = this.$setApiHost;
  },
  methods: {
    setTheme(theme) {  //设置主题
      let self = this;
      this.theme = theme ? theme : this.theme;
      window.CurrentTheme = this.theme;
      let htmlDom = document.getElementsByTagName('html')[0];
      htmlDom.classList.add(this.theme);
      htmlDom.classList.forEach( function(c, ci) {
        if(c != self.theme) {
          htmlDom.classList.remove(c);
        }
      });
      if(theme) {
        //this.reload();
        if(window.gbfc_resetData) {
          window.gbfc_resetData();
        }
      }
      console.log('******* 切换主题 *******')
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/xiayan/Home.vue